import {
  KIRA_LOCAL_STORAGE_NAME,
  LOADING_TRANSLATION_FILE_TEXT,
  TRANSLATION_LANGUAGE
} from './constant';

export const getLoadingText = () => {
  const currentLng =
    localStorage[KIRA_LOCAL_STORAGE_NAME] || TRANSLATION_LANGUAGE.EN;

  return LOADING_TRANSLATION_FILE_TEXT[currentLng];
};
